module.exports = __webpack_public_path__ + "testerstatic/media/logo.25bf045c.svg";